export default (callSign: string) => {
  const snippet =
    `// Somewhere else in the script
    var jwPlayerId = "player";
    player = jwplayer(jwPlayerId).setup({
            file: "http://stream.statsradio.com",
            fallback: 'false',
            autostart: 'true',
            primary: 'html5',
            type: 'mp3',
            width: '0',
            height: '0',
            wmode: 'transparent',
            flashplayer: 'js/jwplayer.flash.swf'
        });

    ra("${callSign}", {
      jwPlayer: {
          instance: player,
      },
    });`;

  return snippet;
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/content/radioAnalytics/snippets/jwPlayerSnippet.js